class OfferPAP {
  constructor(data) {
    this.papId = data.papId
    this.name = data.name
    this.description = data.description
    this.duration = data.duration
    this.type = data.type
    this.typeId = data.typeId
    this.price = data.price
    this.hasPromotionCode = data.hasPromotionCode;
    this.isRecurring = data.isRecurring;
    this.discountedPrice = data.discountedPrice;
    this.currentDiscount = 0;
    this.processing = data.processing;
    this.hasAccess = data.hasAccess;
    this.price_number = data.price_number;
    this.discount_price_number = data.discountedPriceNumber;
    this.currency_code = data.currency_code;
    this.durationId = data.timeUnitId;
    this.durationValue = data.timeUnitValue;
    this.productId = data.productId;
    this.productName = data.productName;
    this.applicationName = data.applicationName;
    this.vat = 0;
  }
}

export default OfferPAP
